import React, { ReactNode } from 'react';

import styles from './RotationStatusLabel.module.scss';

export const RotationStatusLabel = ({
	label,
	rotationKey,
	description,
}: {
	label: string;
	rotationKey?: string;
	// key?: 'high' | 'regular' | 'low' | 'occasional' | 'seasonal' | 'rest';
	description?: string;
}) => (
	<div
		className={`${styles['status-item']} ${getRotationStatusClassName(
			rotationKey,
		)}`}
	>
		<div className={styles['first-row']}>
			<div className={styles.circle} />
			<div className={styles.label}>{label}</div>
		</div>
		<div className={styles['description']}>{description}</div>
	</div>
);

export const getRotationStatusClassName = (key?: string | null) => {
	switch (key) {
		case 'high':
		case 'regular':
		case 'low':
		case 'occasional':
		case 'seasonal':
		case 'rest':
			return `frequency-${key}`;
		default:
			return `frequency-unknown`;
	}
};
